export default "__VITE_ASSET__7cSlMMQC__"